export default __webpack_public_path__ + "static/media/office2-afterA-1920w.c379d360.png";